import { Injectable } from '@angular/core';
import { ExportService } from '@infodata-group/inf-commons';

@Injectable({
  providedIn: 'root',
})
export class AoExportService extends ExportService {
  override buildTitle(title: string) {
    return title;
  }
}
